import { useMemo } from "react";
import shallow from "zustand/shallow";
import { useStoreRoom } from "../store";

export const useSizes = () => {

   const { roomLength, roomDepth, roomHeight } = useStoreRoom((state) => ({
      roomLength: state.length,
      roomDepth: state.depth,
      roomHeight: state.height,
   }), shallow);

   // const totalHeight = useStore((state) => state.totalHeight);
   // const sideIndent = useStore((state) => state.sideIndent);
   // const offsetCeiling = useStore((state) => state.offsetCeiling);
   // const totalLength = useStore((state) => state.totalLength);

   // const totalHeightOfSide = useStore((state) => state.totalHeightOfSide);
   // const sideIndentOfSide = useStore((state) => state.sideIndentOfSide);
   // const offsetCeilingOfSide = useStore((state) => state.offsetCeilingOfSide);
   // const totalLengthOfSide = useStore((state) => state.totalLengthOfSide);



   // const sections = useStore((state) => state.sections, shallow);
   // const firstRackHeight = useStore((state) => state.firstRackHeight);

   // const maxTotalLength = useMemo(() => roomLength - sideIndent, [roomLength, sideIndent]);
   // const minTotalHeight = useMemo(() => {
   //    if (!firstRackHeight) {
   //       return 500;
   //    }
   //    const minTotalHeight = Math.max(...sections.map((section) => section.height), firstRackHeight);
   //    return minTotalHeight;
   // }, [sections]);
   // const minTotalLength: number = useMemo(() => {
   //    if (sections.length === 0) {
   //       return 600;
   //    }
   //    let minTotalLength = 0;
   //    sections.forEach((section) => (minTotalLength += section.width));
   //    return minTotalLength;
   // }, [sections]);
   // const maxTotalHeight = useMemo(() => roomHeight - offsetCeiling, [roomHeight, offsetCeiling]);
   // const minRoomLength = useMemo(() => (
   //    Math.max(sections.reduce((count, section) => count + section.width, 0), 620)
   // ) + sideIndent + BOTTOM_OFFSET, [totalLength, sideIndent]);
   // const minRoomDepth = minRoomLength
   // const minRoomHeight = useMemo(() => (Math.max(sections.reduce((max, section) => max = section.height > max ? section.height : max, 0), 620)) + offsetCeiling + BOTTOM_OFFSET, [totalHeight, offsetCeiling]);
   // const maxSideIndent = useMemo(() => roomLength - totalLength, [roomLength, totalLength]);
   // const maxOffsetCeiling = useMemo(() => roomHeight - totalHeight, [roomHeight, totalHeight]);
   const roomSizes = useMemo(() => ({ width: roomLength, height: roomHeight, depth: roomDepth }), [roomLength, roomHeight, roomDepth]);

   // const maxTotalLengthOfSide = Object.fromEntries(Object.keys(totalHeightOfSide)
   //    .map((side) =>
   //       [side, (['left', 'right'].includes(side) ? roomDepth : roomLength) - sideIndentOfSide[side as 'left' | 'right' | 'back']]
   //    )
   // )

   // const minTotalLengthOfSide = Object.fromEntries(Object.keys(totalHeightOfSide)
   //    .map((side) =>
   //       [side, 600]
   //    )
   // )
   // const maxTotalHeightOfSide = Object.fromEntries(Object.keys(totalHeightOfSide)
   //    .map((side) =>
   //       [side, roomHeight - offsetCeilingOfSide[side as 'left' | 'right' | 'back']]
   //    )
   // )
   // const minTotalHeightOfSide = Object.fromEntries(Object.keys(totalHeightOfSide)
   //    .map((side) =>
   //       [side, 500]
   //    )
   // )
   // const maxSideIndentOfSide = Object.fromEntries(Object.keys(totalHeightOfSide)
   //    .map((side) =>
   //       [side, ['left', 'right'].includes(side) ? roomDepth : roomLength - totalLengthOfSide[side as 'left' | 'right' | 'back']]
   //    )
   // )
   // const maxOffsetCeilingOfSide = Object.fromEntries(Object.keys(totalHeightOfSide)
   //    .map((side) =>
   //       [side, roomHeight - totalHeightOfSide[side as 'left' | 'right' | 'back']]
   //    )
   // )

   return {
      roomLength,
      // totalHeight,
      // sideIndent,
      // offsetCeiling,
      // totalLength,
      roomHeight,
      // maxTotalLength,
      // minTotalLength,
      // maxTotalHeight,
      // minRoomLength,
      // minRoomHeight,
      // maxSideIndent,
      // maxOffsetCeiling,
      // minTotalHeight,
      roomSizes,
      // firstRackHeight,
      roomDepth,
      // minRoomDepth,

      // maxTotalLengthOfSide,
      // minTotalLengthOfSide,
      // maxTotalHeightOfSide,
      // minTotalHeightOfSide,
      // maxSideIndentOfSide,
      // maxOffsetCeilingOfSide,

      // totalHeightOfSide,
      // sideIndentOfSide,
      // offsetCeilingOfSide,
      // totalLengthOfSide,
   };
};
